import gql from 'graphql-tag';

export const all = gql`query getFogs {
    fogs {
        id
        archived
        reference
        creationDate
        overageClientRate
        overageUnderwriterRate
        voyageNb
        notes
        overage
        coverType
        rebateRate
        brokerageReturn
        comments
        vat8
        documents {
            id
            creationDate
            type
            url
            accountancyUrl
            basename
            canceled
        }

        client {
            id
            name
        }
        currency {
            id
            symbol
            isoCode
        }

        vessel {
            id
            name
            year
        }

        underwriter {
            id
            name
            rebateRate
        }

        invoices {
            id
            amount
            label
            documentType
        }

        costs {
            id
            invoiceNumber
        }

        cargos {
            id
            quantity
            perTonUsd
            value
            outturnTonnes
            customerReference
            receiver
            blDate
            blNumber
            certificateReference
            supplier
            stowage
            excessExclusion

            commodity{
                id
                name
                commodityGroup {
                    id
                    name
                }
            }

            cargoPorts {
                id
                cargo {
                    id
                }
                port {
                    id
                    country {
                        id
                        name
                    }
                }
                operation
                estimatedTimeOfArrival
                isConfirmed
            }

            clientRate {
                id
                name
                creationDate
                client {
                    id
                }
                isMarineOnly
                rate
                franchise
            }
            underwriterRate {
                id
                name
                rate
                company {
                    id
                    name
                }
            }
        }
    }
}`;

export const activeAndInactive = gql`query getFogs($displayAll: Boolean) {
    fogs(displayAll: $displayAll) {
        id
        archived
        reference
        creationDate
        overageClientRate
        overageUnderwriterRate
        voyageNb
        notes
        overage
        coverType
        rebateRate
        brokerageReturn
        comments
        vat8
        documents {
            id
            creationDate
            type
            url
            accountancyUrl
            basename
            canceled
        }

        client {
            id
            name
        }
        currency {
            id
            symbol
            isoCode
        }

        vessel {
            id
            name
            year
        }

        underwriter {
            id
            name
            rebateRate
        }

        invoices {
            id
            amount
            label
            documentType
        }

        costs {
            id
            invoiceNumber
        }

        cargos {
            id
            quantity
            perTonUsd
            value
            outturnTonnes
            customerReference
            receiver
            blDate
            blNumber
            certificateReference
            supplier
            stowage
            excessExclusion

            commodity{
                id
                name
                commodityGroup {
                    id
                    name
                }
            }

            cargoPorts {
                id
                cargo {
                    id
                }
                port {
                    id
                    country {
                        id
                        name
                    }
                }
                operation
                estimatedTimeOfArrival
                isConfirmed
            }

            clientRate {
                id
                name
                creationDate
                client {
                    id
                }
                isMarineOnly
                rate
                franchise
            }
            underwriterRate {
                id
                name
                rate
                company {
                    id
                    name
                }
            }
        }
    }
}`;


export const get = gql`query getFog($id: ID!) {
    fog (id: $id){
        id
        archived
        reference
        creationDate
        overageClientRate
        overageUnderwriterRate
        voyageNb
        notes
        overage
        coverType
        rebateRate
        brokerageReturn
        comments
        vat8
        documents {
            id
            creationDate
            type
            url
            accountancyUrl
            basename
            canceled
        }
        
        client {
            id
            name
        }
        currency {
            id
            symbol
            isoCode
        }

        vessel {
            id
            name
            year
        }

        underwriter {
            id
            name
            rebateRate
        }
        
        invoices {
            id
            amount
            label
            documentType
        }

        costs {
            id
            invoiceNumber
        }

        cargos {
            id
            quantity
            perTonUsd
            value
            outturnTonnes
            customerReference
            receiver
            blDate
            blNumber
            certificateReference
            supplier
            stowage
            excessExclusion
            commodity{
                id
                name
                commodityGroup {
                    id
                    name
                }
            }

            cargoPorts {
                id
                cargo {
                    id
                }
                port {
                    id
                    country {
                        id
                        name
                    }
                }
                operation
                estimatedTimeOfArrival
                isConfirmed
            }

            clientRate {
                id
                name
                creationDate
                client {
                    id
                }
                isMarineOnly
                rate
                franchise
            }
            underwriterRate {
                id
                name
                rate
                company {
                    id
                    name
                }
            }

        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/fog.js